import { Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'

import Text from '../shared/text/Text'

const FollowersMultipliers = ({ t }) => {
  const data = [
    {
      label: '< 100',
      value: 0.5
    },
    {
      label: "101 - 1'000",
      value: 1
    },
    {
      label: "1'001 - 10'000",
      value: 1.25
    },
    {
      label: "10'001 - 100'000",
      value: 1.5
    },
    {
      label: "> 100'000",
      value: 2
    }
  ]
  return (
    <Card sx={{ p: 3 }}>
      <CardHeader
        title={t('earn-via.followers-multipliers')}
        subheader={t('earn-via.followers-multipliers-desc')}
        sx={{ p: 0 }}
      />
      <Stack spacing={1} mt={2}>
        {data.map(({ label, value }) => (
          <Stack key={label} direction='row' justifyContent='space-between'>
            <Stack spacing={0.5} direction='row' alignItems='center'>
              <Text
                variant='subtitle2'
                label={`${label} ${t('earn-via.followers-lower')}`}
              />
            </Stack>
            <Text label={t('earn-via.multi', { value })} />
          </Stack>
        ))}
      </Stack>
    </Card>
  )
}

export default memo(FollowersMultipliers)
